module.exports = __webpack_public_path__ + "img/cooperate1.4a376fed.png";